import React from 'react';
import InfoNote from '../BuildingBlocks/Notes/InfoNote';

export default function PendingPlanNote() {
  return (
    <InfoNote text="If you have not connected your platform and/or bank account, your final Growth Plan may differ from the below." />
  );
}
